import { inspections } from "@/api/inspect/inspectSpecification/useInspectionQuery";
import {
  NoDataTr,
  PaginationWrapper,
  TabBodyTable,
  TabBodyTitle,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  WorkTabBodyContainer,
} from "@/features/work/WorkView/WorkProductionHistory";
import { DateSlashtimeUtil } from "@/utils/dateTimeUtil";
import { Pagination, Text } from "@mantine/core";
import { InspectionsGet200ResponseRowsInner } from "@sizlcorp/sizl-api-document/dist/models";
import { IconMinus, IconPlus } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
interface WorkInspectRecordProps {
  productionPlanId: number | undefined;
}
export const WorkInspectRecord = (props: WorkInspectRecordProps) => {
  const { productionPlanId } = props;
  const [activePage, setActivePage] = useState<number>(1);
  const { t } = useTranslation();

  const [expandedRows, setExpandedRows] = useState<{ [key: number]: boolean }>({});

  const { data } = useQuery(
    inspections.get({
      query: {
        $and: [{ productionPlanId: productionPlanId }],
      },
      populate: ["lot"],
      sort: "-id",
    }),
  );

  const rows: InspectionsGet200ResponseRowsInner[] = data?.data?.rows || [];

  const toggleRow = (id: number) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  let recordIndex = 0;

  return (
    <WorkTabBodyContainer>
      <TabBodyTitle>
        <Text fz="xl" fw={500}>
          {t("workTab.inspectRecord")}
        </Text>
        <Text fz="xs" fw={400}>
          {t("inspectRecord.description")}
        </Text>
      </TabBodyTitle>
      <TabBodyTable>
        <Thead>
          <Tr>
            <Th width={40}></Th>
            <Th style={{ width: "95%" }}>{t("inspectRecord.inspectId")}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {rows.length ? (
            rows.map((inspection, index) => (
              <>
                <Tr>
                  <Td width={60}>
                    {!expandedRows[inspection.id] && (
                      <IconPlus onClick={() => toggleRow(inspection.id)} />
                    )}
                    {expandedRows[inspection.id] && (
                      <IconMinus onClick={() => toggleRow(inspection.id)} />
                    )}
                  </Td>
                  <Td width={160} style={{ justifyContent: "center" }}>
                    {inspection.id}
                  </Td>
                  <Td style={{ fontWeight: "bold" }} width={430}>
                    {t("lot.id")} : {inspection.lotId}
                  </Td>
                  <Td style={{ fontWeight: "bold" }} width={430}>
                    {t("lot.name")} : {inspection.lot?.name}
                  </Td>
                </Tr>
                {expandedRows[inspection.id] && (
                  <>
                    <Tr>
                      <Th width={60}></Th>
                      <Th width={160}>{t("inspectRecord.inspectCategory")}</Th>
                      <Th width={300}>{t("inspectRecord.first")}</Th>
                      <Th width={300}>{t("inspectRecord.middle")}</Th>
                      <Th width={300}>{t("inspectRecord.last")}</Th>
                    </Tr>
                    {inspection?.specificationData?.criteria?.map((criteria) => (
                      <>
                        <Tr>
                          <Td width={60}></Td>
                          <Td width={160}>{criteria.name}</Td>
                          {inspection?.record?.[recordIndex]?.map(
                            (recordItem: any, itemIndex: number) => {
                              const widths =
                                inspection?.record?.[recordIndex]?.length === 3
                                  ? [300, 300, 300]
                                  : inspection?.record?.[recordIndex]?.length === 2
                                    ? [450, 450]
                                    : [900];
                              return (
                                <>
                                  <Td width={widths[itemIndex]} key={itemIndex}>
                                    {(() => {
                                      const resultValue = recordItem?.isSaved
                                        ? recordItem?.value
                                          ? t("inspectRecord.acceptance")
                                          : t("inspectRecord.failure")
                                        : "";
                                      const resultName = recordItem?.isSaved
                                        ? recordItem?.creatorUserName
                                        : "";
                                      const resultDate = recordItem?.isSaved
                                        ? DateSlashtimeUtil(recordItem?.createdAt)
                                        : "";
                                      return resultValue ? (
                                        <>
                                          <Text>
                                            <Text
                                              style={{
                                                color: resultValue === "합격" ? "green" : "red",
                                              }}
                                            >
                                              {`${resultValue}`}
                                            </Text>
                                            {`\n${t("inspectRecord.inspector")} : ${resultName}\n${t("inspectRecord.createdAt")} : ${resultDate}`}
                                          </Text>
                                        </>
                                      ) : (
                                        ""
                                      );
                                    })()}
                                  </Td>
                                </>
                              );
                            },
                          )}
                        </Tr>
                      </>
                    ))}
                  </>
                )}
              </>
            ))
          ) : (
            <NoDataTr>
              <Text>{t("inspectRecord.notFound")}</Text>
            </NoDataTr>
          )}
        </Tbody>
      </TabBodyTable>
      <PaginationWrapper>
        <Pagination
          onChange={setActivePage}
          value={activePage}
          total={data?.data?.totalPages ?? 0}
          size="lg"
          radius="sm"
        />
      </PaginationWrapper>
    </WorkTabBodyContainer>
  );
};
